var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ConfirmDialog',{attrs:{"body":_vm.messageBody,"cancel":_vm.$strings.calls.incomingDialog.cancel,"ok":_vm.$strings.calls.incomingDialog.confirm},on:{"cancel":_vm.declineCall,"confirm":_vm.acceptCall},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }